import { LeadTime } from '@digital-bridge/artisan-arya';
import { ConfigurableProperties } from '@dora/backpack';
import * as Gift from './gift/product';
import { Summary } from './summary';
import * as S from './summary';

export type Product = {
    sku: string;
    kind: 'simple' | 'bundle';
    range: string[];
    summary: Summary;
    price: number;
    originalPrice?: number;
    // Information about the time a customer will need to wait to receive this product if purchased.
    // LeadTime can be missing if the retailer does not provide us with a valid lead time for a given product,
    // which may happen for reasons outside of our control.
    // This is considered acceptable and we handle this in the lead time aggregation logic and the UI.
    leadTime?: LeadTime;
    articles: { [articleType: string]: { thumbnail?: string } };
    groupingCode?: string;
    configurableProperties?: ConfigurableProperties.Gift;
    properties: {
        rattan_colour?: ConfigurableProperties.FinishT;
        table_finish?: ConfigurableProperties.FinishT;
        dimension?: ConfigurableProperties.DimensionT;
        finish?: ConfigurableProperties.FinishT;
        [key: string]: unknown;
    };
    discontinued: boolean;
    thumbnail?: string;
};

export function productId(p: Product) {
    return p.sku;
}

export function summary(p: Product) {
    return p.summary;
}

export function summaryName(p: Product) {
    return S.getName(summary(p));
}

export function summaryImage(p: Product) {
    return S.getImage(summary(p));
}

export function fromGiftProduct(gp: Gift.Product): Product {
    return {
        sku: gp.canonicalId,
        // product.kind can only be undefined on simple products
        kind: gp.kind ?? 'simple',
        summary: Gift.summary(gp),
        leadTime: gp.leadTime,
        price: gp.price.saleValue ?? gp.price.value,
        originalPrice: gp.price.saleValue ? gp.price.value : undefined,
        range: (gp.properties.range ?? []) as string[],
        articles: gp.kind === 'bundle' ? { productSet: {} } : gp.articles,
        groupingCode: (gp.kind === 'simple' ? gp.groupingCode : undefined) ?? undefined,
        configurableProperties: gp.kind === 'simple' ? gp.configurableProperties : undefined,
        properties: gp.properties,
        discontinued: gp.discontinued,
        thumbnail: gp.thumbnailUrl ?? undefined,
    };
}
